// utils/axiosRequestManager.ts

// utils/AxiosRequestManager.ts

export class AxiosRequestManager {
  private static controllerMap: Map<string, AbortController[]> = new Map();

  static addController(key: string, controller: AbortController, allowMultiple = false) {
    if (allowMultiple) {
      // Keep multiple controllers
      const existing = this.controllerMap.get(key) || [];
      existing.push(controller);
      this.controllerMap.set(key, existing);
    } else {
      // Cancel and replace previous
      this.cancelControllers(key);
      this.controllerMap.set(key, [controller]);
    }
  }

  static removeController(key: string, controller?: AbortController) {
    if (!this.controllerMap.has(key)) return;

    if (controller) {
      // remove only the specific one
      const arr = this.controllerMap.get(key)!.filter(c => c !== controller);
      if (arr.length) {
        this.controllerMap.set(key, arr);
      } else {
        this.controllerMap.delete(key);
      }
    } else {
      this.controllerMap.delete(key);
    }
  }

  static getControllers(key: string): AbortController[] | undefined {
    return this.controllerMap.get(key);
  }

  static cancelControllers(key: string) {
    const controllers = this.controllerMap.get(key);
    if (controllers) {
      controllers.forEach(c => c.abort());
      this.controllerMap.delete(key);
    }
  }

  static cancelAll() {
    this.controllerMap.forEach(arr => arr.forEach(c => c.abort()));
    this.controllerMap.clear();
  }
}

// export class AxiosRequestManager {
//   // Store controllers keyed by the URL
//   private static controllerMap: Map<string, AbortController> = new Map();
//   // Add or replace the controller for a given API endpoint
//   static addController(key: string, controller: AbortController,allowMultiple = false) {
//     const existingController = this.controllerMap.get(key);
//     if (existingController) {
//       existingController.abort(); // Abort previous request if exists
//     }
//     this.controllerMap.set(key, controller); // Store the new controller
//   }

//   // Remove controller after request is complete
//   static removeController(key: string) {
//     this.controllerMap.delete(key);
//   }
//   // Get the controller by the unique key
//   // Get the controller by the unique key (method + URL)
//   static getController(key: string): AbortController | undefined {
//     return this.controllerMap.get(key);
//   }
//   // Cancel all ongoing requests (global cancel)
//   static cancelAll() {
//     this.controllerMap.forEach((controller) => controller.abort());
//     this.controllerMap.clear();
//   }
//   // private static controllers: AbortController[] = [];

//   // static addController(controller: AbortController) {
//   //   this.controllers.push(controller);
//   // }

//   // static cancelAll() {
//   //   this.controllers.forEach((controller) => controller.abort());
//   //   this.controllers = []; // Clear after cancel
//   // }
// }
